import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type MoonIconProps = Partial<SVGIconProps>;

const MoonIcon: FC<MoonIconProps> = (props) => (
  <SVGIcon viewBox="0 0 13 13" {...props}>
    <path
      d="M2.85829 2.89931C2.85829 2.5182 2.89218 2.14474 2.95753 1.78203C1.81775 2.73071 1.09274 4.15984 1.09274 5.7576C1.09285 8.61269 3.40733 10.9272 6.26242 10.9273C7.8602 10.9273 9.28877 10.2018 10.2375 9.06195C9.87488 9.12726 9.50167 9.16173 9.12071 9.16173C5.662 9.1617 2.85832 6.35802 2.85829 2.89931ZM3.95103 2.89931C3.95106 5.75452 6.2655 8.06896 9.12071 8.06899C9.88032 8.06899 10.6003 7.90543 11.2486 7.61226C11.4557 7.51864 11.6993 7.56313 11.86 7.72378C12.0207 7.8845 12.0651 8.12811 11.9715 8.33524C10.9894 10.5069 8.80307 12.02 6.26242 12.02C2.80383 12.0199 0.000116577 9.21619 0 5.7576C0 3.21695 1.51309 1.03061 3.68478 0.0484875C3.89191 -0.0450893 4.13552 -0.000722468 4.29624 0.160002C4.45689 0.320758 4.50138 0.564368 4.40776 0.771464C4.11459 1.41972 3.95103 2.1397 3.95103 2.89931Z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default MoonIcon;
